const slaAlertColor = {
    low: '#0acf97',
    normal: '#e2e135',
    high: '#f5950a',
    urgent: '#e64231',
}

export { slaAlertColor }
